<div class="cellular-edit-component" [class.full-width]="config.fullWidth" [class.wizard]="config.isInWizard">
    <h2 *ngIf="!config.hideTitle" mat-dialog-title>Edit Cellular Provider</h2>

    <div [hidden]="submissionStatus.inProgress">
        <ng-container *ngIf="shouldShowUpdateProviderError; else basicWarning">
            <div class="alert-margin">
                <clare-update-provider-warning
                    [isOnline]="isProjectOnline"
                    [error]="updateProviderError"
                    (onFormSubmit)="updateCarrierDCOProp()"
                ></clare-update-provider-warning>
            </div>
        </ng-container>

        <ng-template #basicWarning>
            <div *ngIf="error" class="alert alert-danger2 alert-margin">
                <div><mat-icon>warning</mat-icon>{{ error.text }}</div>
            </div>
        </ng-template>
    </div>

    <div class="alert alert-danger2 alert-margin" *ngIf="isIccidMismatch">
        <div>
            <mat-icon>warning</mat-icon> The stored ICCID does not match the panel's current ICCID.
            <span *ngIf="!isCellActive; else cellIsActive">Please update the ICCID below before activating.</span>
            <ng-template #cellIsActive>
                <span>Please deactivate the ICCID below before activating the correct ICCID.</span>
            </ng-template>
        </div>
    </div>
    <form [formGroup]="cellularForm">
        <div [hidden]="submissionStatus.inProgress">
            <div class="fieldset clearfix">
                <p>
                    <!-- Inputs are readonly instead of disabled because disabling removes them from FormGroup.value, disables validation, etc -->
                    <mat-form-field [class.readonly-wrapper]="isCellActive" appearance="outline" *letVar="fields.provider as field">
                        <mat-label>Cellular Provider</mat-label>
                        <select
                            [class.readonly-block]="isCellActive"
                            [readonly]="isCellActive"
                            cdkFocusInitial
                            matNativeControl
                            id="provider"
                            formControlName="provider"
                        >
                            <option disabled value="">Select a provider</option>
                            <option [readonly]="isCellActive" *ngFor="let provider of providerList" [value]="provider.type">
                                {{ provider.label }}
                            </option>
                        </select>
                        <mat-error>
                            <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                        </mat-error>
                    </mat-form-field>
                </p>
                <p>
                    <mat-form-field appearance="outline" *letVar="fields.iccid as field">
                        <mat-label>ICCID</mat-label>
                        <input
                            [readonly]="isCellActive || isVerifiedPanelIccid"
                            matInput
                            id="iccid"
                            type="text"
                            placeholder="ICCID"
                            formControlName="iccid"
                            required
                        />
                        <mat-error>
                            <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                        </mat-error>
                    </mat-form-field>
                </p>
                <p *ngIf="hasPostal">
                    <mat-form-field appearance="outline" *letVar="fields.mdnZipCode as field">
                        <mat-label>ZIP Code</mat-label>
                        <input
                            [readonly]="isCellActive"
                            matInput
                            id="zipcode"
                            type="text"
                            placeholder="ZIP Code"
                            formControlName="mdnZipCode"
                            required
                        />
                        <mat-error>
                            <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                        </mat-error>
                    </mat-form-field>
                </p>
                <p>
                    <mat-form-field appearance="outline" *letVar="fields.macAddress as field">
                        <mat-label>Panel MAC Address</mat-label>
                        <input
                            [readonly]="isCellActive"
                            matInput
                            id="mac"
                            type="text"
                            placeholder="MAC Address"
                            mac-inp
                            formControlName="macAddress"
                            required
                        />
                        <mat-error>
                            <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                        </mat-error>
                    </mat-form-field>
                </p>
                <p *ngIf="coverageMapUrl">
                    <a [href]="coverageMapUrl" target="_blank" rel="noopener noreferrer">Show Coverage Map</a>
                </p>
            </div>
        </div>
        <div
            *ngIf="submissionStatus.altText && submissionStatus.inProgress"
            [class.padded-spinner]="config.paddedSpinner"
            class="long-status"
        >
            {{ submissionStatus.altText }}
        </div>
        <div
            *ngIf="submissionStatus.inProgress"
            [class.left-align]="config.leftAlignSpinner"
            [class.padded-spinner]="config.paddedSpinner"
            class="spinner-container"
        >
            <clare-spinner text="{{ submissionStatus.text }}" [textAlign]="config.leftAlignSpinner ? 'left' : 'center'"></clare-spinner>
        </div>
        <div [hidden]="config.hideSubmit && submissionStatus.inProgress">
            <div class="button-wrapper mat-dialog-actions">
                <button
                    type="button"
                    mat-raised-button
                    *ngIf="cellularProviderAction"
                    (click)="callProviderWithAction(cellularProviderAction, cellularForm)"
                    color="{{ cellularProviderAction === 'deactivate' ? 'warn' : 'primary' }}"
                    class="cellularProviderAction"
                    [disabled]="shouldDisableSubmit"
                >
                    {{ buttonText }}
                </button>
            </div>
        </div>
    </form>
</div>
